import React from "react";
import { BasicFieldProps } from "./props";
import classNames from "classnames";

export const Hidden = ({ field, fieldId }: BasicFieldProps): JSX.Element => {
  const { label, cssClass = "", id } = field;
  // Gravity Form field ID ~ name.
  const gfName = `input_${id}`;
  return (
    <div
      className={classNames({
        [cssClass]: cssClass,
        "hidden-input": true,
      })}
    >
      <label htmlFor={fieldId}>{label}</label>
      <input name={gfName} id={fieldId} type="hidden" />
    </div>
  );
};
